<template>
  <div class="container">
    <v-data-table
      :headers="headers"
      :items="items"
      sort-by="calories"
      class="elevation-1"
      disable-pagination
      disable-filtering
      hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Προϊόντα</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="m-2" v-bind="attrs" v-on="on">
                ΔΗΜΙΟΥΡΓΙΑ
              </v-btn>
              <v-btn color="success" dark class="m-2" @click="excelPlease" v-show="showExport" v-bind:loading="getExcelButtonDisabled">
                ΕΞΑΓΩΓΗ
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            v-model="editedItem.code"
                            label="Κωδικός"
                            v-bind:error-messages="allerrors.code">
                        </v-text-field>

                        <v-text-field
                            v-model="editedItem.description"
                            label="Περιγραφή"
                            v-bind:error-messages="allerrors.description">
                        </v-text-field>

                        <v-select
                            label="Κατηγορία"
                            v-model="editedItem.productCategory"
                            v-bind:items="product_categories"
                            item-text="name"
                            item-value="id"
                            clearable
                            return-object
                            v-bind:error-messages="allerrors.product_category_id">
                        </v-select>

                        <v-select
                            label="Μονάδα Μέτρησης"
                            v-model="editedItem.measurementUnit"
                            v-bind:items="measurement_units"
                            item-text="description"
                            item-value="id"
                            clearable
                            return-object
                            v-bind:error-messages="allerrors.measurement_unit_id">
                        </v-select>

                        <v-select
                            label="Κατηγορία ΦΠΑ"
                            v-model="editedItem.vatCategory"
                            v-bind:items="vat_categories"
                            item-text="description"
                            item-value="id"
                            clearable
                            return-object
                            v-bind:error-messages="allerrors.vat_category_id">
                        </v-select>

                        <v-select
                            label="Κατηγορία εσόδου"
                            v-model="editedItem.incomeCategory"
                            v-bind:items="income_categories"
                            item-text="description"
                            item-value="id"
                            clearable
                            return-object
                            v-bind:error-messages="allerrors.income_category_id">
                        </v-select>

                        <vuetify-money
                            v-model="editedItem.suggested_price"
                            label="Προτεινόμενη τιμή"
                            v-bind:options="moneyFieldOptions">
                        </vuetify-money>

                        <vuetify-money
                            v-model="editedItem.suggested_purchase_price"
                            label="Προτεινόμενη τιμή αγοράς"
                            v-bind:options="moneyFieldOptions">
                        </vuetify-money>

                        <v-text-field
                            v-model="editedItem.logariasmos_esodon"
                            label="Λογαριασμός εσόδων"
                            v-bind:error-messages="allerrors.code">
                        </v-text-field>

                        <v-text-field
                            v-model="editedItem.logariasmos_eksodon"
                            label="Λογαριασμός εξόδων"
                            v-bind:error-messages="allerrors.code">
                        </v-text-field>

                        <v-text-field
                            v-model="editedItem.logariasmos_fpa_esodon"
                            label="Λογαριασμός ΦΠΑ εσόδων"
                            v-bind:error-messages="allerrors.code">
                        </v-text-field>

                        <v-text-field
                            v-model="editedItem.logariasmos_fpa_eksodon"
                            label="Λογαριασμός ΦΠΑ εξόδων"
                            v-bind:error-messages="allerrors.code">
                        </v-text-field>

                        <v-select
                            label="Προμηθευτής"
                            v-model="editedItem.supplier_id"
                            v-bind:items="accounts"
                            item-text="name"
                            item-value="id"
                            clearable
                            v-bind:error-messages="allerrors.measurement_unit_id">
                        </v-select>

                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="close">ΑΚΥΡΟ</v-btn>
                <v-btn color="blue darken-1" text @click="save" v-bind:loading="saveButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Διαγραφή εγγραφής "{{ editedItem.code }}";</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" text @click="deleteItemConfirm" v-bind:loading="deleteButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
      <template v-slot:[`item.suggested_price`]="{ item }">
        {{ formatPrice(item.suggested_price) }}
      </template>
      <template v-slot:[`item.suggested_purchase_price`]="{ item }">
        {{ formatPrice(item.suggested_purchase_price) }}
      </template>
      <template v-slot:[`item.last_purchase_unit_price`]="{ item }">
        {{ formatPrice(item.last_purchase_unit_price) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    data: () => ({
      getExcelButtonDisabled: false,

      moneyFieldOptions: {
          locale: "el-GR",
          prefix: "€",
          suffix: "",
          length: 12,
          precision: 4
      },
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Κωδικός',
          align: 'start',
          //sortable: false,
          value: 'code',
        },
        { 
          text: 'Περιγραφή', 
          value: 'description' 
        },
        { 
          text: 'Κατηγορία', 
          value: 'productCategory.name' 
        },
        { 
          text: 'Τιμη πώλησης', 
          value: 'suggested_price',
          exportTransformer: (cell) => cell.replace('.', ',')
        },
        { 
          text: 'Τιμή αγοράς', 
          value: 'suggested_purchase_price',
          exportTransformer: (cell) => cell.replace('.', ',')
        },
        { 
          text: 'Τελευταία τιμή αγοράς', 
          value: 'last_purchase_unit_price',
          exportTransformer: (cell) => cell.replace('.', ',')
        },
        { 
          text: 'Λογ. Εσόδων', 
          value: 'logariasmos_esodon' 
        },
        { 
          text: 'Λογ. Εξόδων', 
          value: 'logariasmos_eksodon' 
        },
        { 
          text: 'Απόθεμα', 
          value: 'stock_count',
          exportTransformer: (cell) => cell.replace('.', ',') 
        },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      allerrors: [],
      items: [],
      accounts: [],
      products: [],
      measurement_units: [],
      vat_categories: [],
      income_categories: [],

      product_categories: [],

      editedIndex: -1,
      editedItem: {
        code: '',
        description: '',
        measurementUnit: {},
        vatCategory: {},
        productCategory: {},
        incomeCategory: {},
        suggested_price: 0,
        suggested_purchase_price: 0,
        logariasmos_esodon: '',
        logariasmos_eksodon: '',
        logariasmos_fpa_eksodon: '',
        logariasmos_fpa_esodon: ''
      },

      defaultItem: {
        code: '',
        description: '',
        measurementUnit: {},
        vatCategory: {},
        productCategory: {},
        incomeCategory: {},
        suggested_price: 0,
        suggested_purchase_price: 0,
        logariasmos_esodon: '',
        logariasmos_eksodon: '',
        logariasmos_fpa_eksodon: '',
        logariasmos_fpa_esodon: ''
      },
      saveButtonDisabled: false,
      deleteButtonDisabled: false
    }),

    computed: {
      showExport() {
        return this.items?.length > 0
      },

      formTitle () {
        return this.editedIndex === -1 ? 'Προσθήκη' : 'Επεξεργασία'
      },

      editedItemName () {
        return 'yay'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {

      excelPlease() {
        if (this.items?.length > 0 == false) {
          console.log('No items!')
          return
        }

        const transform = (line, columnDefinitions) => {
          let out = []

          columnDefinitions.forEach(columnDefinition => {

            const columnValue = line[columnDefinition.propertyName]

            if (columnDefinition.exportTransformer)
              out.push(columnDefinition.exportTransformer(columnValue))
            else
              out.push(columnValue)
          });

          return out;
        }

        const exportableColumns = this.headers.filter(x => (x.exportable ?? true) == true)
        const columnDefinitions = exportableColumns.map(x => ({ propertyName: x.value, exportTransformer: x.exportTransformer }))

        const requestBody = {
          table_headers: exportableColumns.map(x => x.text),
          table_entries: this.items.map(line => transform(line, columnDefinitions))
        }

        this.axiosDownload('/api/test', requestBody, 'αναφορά.xls')
      },

      axiosDownload(url, requestBody, filename) {
        this.getExcelButtonDisabled = true;

        axios({
            url: url, 
            data: requestBody,
            method: 'POST',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.getExcelButtonDisabled = false
        // link.remove();
        // url.remove();

        }).catch(err => { console.log(err); this.getExcelButtonDisabled = false})
      },

      mixmatch(product) {
        product.vatCategory = this.vat_categories.find(x => x.id == product.vat_category_id)
        product.measurementUnit = this.measurement_units.find(x => x.id == product.measurement_unit_id)
        
        if (product.income_category_id != null)
          product.incomeCategory = this.income_categories.find(x => x.id == product.income_category_id)

        if (product.category_id != null)
          product.productCategory = this.product_categories.find(x => x.id == product.category_id)
        
        return product;
      },

      initialize () {
        axios.all([
          axios.get('/api/measurement-units'),
          axios.get('/api/product-categories'),
          axios.get('/api/tax-authority/vat-categories'),
          axios.get('/api/tax-authority/income-categories'),
          axios.get('/api/products'),
          axios.get('/api/accounts')
        ])
        .then(axios.spread((measurementUnitsResponse, productCategoriesResponse, vatCategoriesResponse, incomeCategoriesResponse, productsResponse, accountsResponse) => {
          this.measurement_units = measurementUnitsResponse.data
          this.product_categories = productCategoriesResponse.data
          this.vat_categories = vatCategoriesResponse.data
          this.income_categories = incomeCategoriesResponse.data
          this.products = productsResponse.data
          this.items = this.products.map(product => this.mixmatch(product))
          this.accounts = accountsResponse.data.map(function (account) { return { id: account.id, name: account.name}})

        }))
        .catch(error => { console.log(error) })
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.deleteButtonDisabled = true;
        axios.delete(`/api/products/${this.items[this.editedIndex].id}`)
        .then(response => { this.items.splice(this.editedIndex, 1); this.closeDelete(); })
        .catch(error => console.log(error))
        .finally(() => this.deleteButtonDisabled = false)
      },

      formatPrice(value) {
          let val = parseFloat(value);
          if (isNaN(val)) return '';
          return val.toFixed(2).replace('.', ',');
      },

      close () {
        this.allerrors = []
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        this.saveButtonDisabled = true;
        
        let requestBody = {
          code: this.editedItem.code,
          description: this.editedItem.description,
          vat_category_id: this.editedItem.vatCategory.id,
          category_id: this.editedItem.productCategory?.id ?? null,
          measurement_unit_id: this.editedItem.measurementUnit.id,
          suggested_price: this.editedItem.suggested_price,
          suggested_purchase_price: this.editedItem.suggested_purchase_price,
          income_category_id: this.editedItem.incomeCategory?.id ?? null,
          logariasmos_esodon: this.editedItem.logariasmos_esodon ?? null,
          logariasmos_eksodon: this.editedItem.logariasmos_eksodon ?? null,
          logariasmos_fpa_esodon: this.editedItem.logariasmos_fpa_esodon ?? null,
          logariasmos_fpa_eksodon: this.editedItem.logariasmos_fpa_eksodon ?? null,
          supplier_id: this.editedItem.supplier_id ?? null
        }

        if (this.editedIndex > -1) {
          //Object.assign(this.items[this.editedIndex], this.editedItem)
          axios.patch(`/api/products/${this.editedItem.id}`, requestBody )
          .then(response => { 
            const newObjectInstance = this.mixmatch(response.data);
            console.log(newObjectInstance)

            Object.assign(this.items[this.editedIndex], newObjectInstance); this.close(); })
          .catch(error => {
            console.log(error)

            if (error.response.data.errors)
              this.allerrors = error.response.data.errors

          })
          .finally(() => this.saveButtonDisabled = false)
        } else {

          axios.post('/api/products', requestBody )
          .then(response => { console.log(response.data); this.items.push(this.mixmatch(response.data)); this.close(); })
          .catch(error => {
            console.log(error)

            if (error.response.data.errors)
              this.allerrors = error.response.data.errors

          })
          .finally(() => this.saveButtonDisabled = false)
          
        }
      },
    },
  }
</script>

<style>
</style>